import createIcon from '../../createIcon';

/**
 * @component @name ImportContacts
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuNSAzLjVDMTUuNTUgMy41IDEzLjQ1IDMuOSAxMiA1QzEwLjU1IDMuOSA4LjQ1IDMuNSA2LjUgMy41QzQuNTUgMy41IDIuNDUgMy45IDEgNVYxOS42NUMxIDIwLjMgMS43MyAyMC4xIDEuNzUgMjAuMUMzLjEgMTkuNDUgNS4wNSAxOSA2LjUgMTlDOC40NSAxOSAxMC41NSAxOS40IDEyIDIwLjVDMTMuMzUgMTkuNjUgMTUuOCAxOSAxNy41IDE5QzE5LjE1IDE5IDIwLjg1IDE5LjMgMjIuMjUgMjAuMDVDMjIuNjYgMjAuMjYgMjMgMTkuODYgMjMgMTkuNlY1QzIxLjUxIDMuODggMTkuMzcgMy41IDE3LjUgMy41Wk0yMSAxNy41QzE5LjkgMTcuMTUgMTguNyAxNyAxNy41IDE3QzE1LjggMTcgMTMuMzUgMTcuNjUgMTIgMTguNVY3QzEzLjM1IDYuMTUgMTUuOCA1LjUgMTcuNSA1LjVDMTguNyA1LjUgMTkuOSA1LjY1IDIxIDZWMTcuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ImportContacts = createIcon('ImportContacts', [
  [
    'path',
    {
      d: 'M17.5 3.5C15.55 3.5 13.45 3.9 12 5C10.55 3.9 8.45 3.5 6.5 3.5C4.55 3.5 2.45 3.9 1 5V19.65C1 20.3 1.73 20.1 1.75 20.1C3.1 19.45 5.05 19 6.5 19C8.45 19 10.55 19.4 12 20.5C13.35 19.65 15.8 19 17.5 19C19.15 19 20.85 19.3 22.25 20.05C22.66 20.26 23 19.86 23 19.6V5C21.51 3.88 19.37 3.5 17.5 3.5ZM21 17.5C19.9 17.15 18.7 17 17.5 17C15.8 17 13.35 17.65 12 18.5V7C13.35 6.15 15.8 5.5 17.5 5.5C18.7 5.5 19.9 5.65 21 6V17.5Z',
      key: '1ih8tx',
    },
  ],
]);

export default ImportContacts;
